import React, { useState } from "react";
import { AlertTriangle, ExternalLink, X } from "lucide-react";

export function Disclaimer() {
  const [hidden, setHidden] = useState(false);
  if (hidden) return null;
  return (
    <div className="bg-amber-50 border-b border-amber-200 text-amber-900 px-4 py-3 text-sm flex items-start gap-3" data-testid="disclaimer-banner">
      <AlertTriangle size={18} className="flex-shrink-0 mt-0.5 text-amber-600" />
      <div className="flex-1 leading-relaxed">
        <strong>Disclaimer:</strong> Op deze website kunnen fouten staan. Raadpleeg altijd de officiële reglementen via{" "}
        <a
          href="https://dutchgymnastics.nl/trainers-en-coaches/disciplines/groepsspringen/documenten"
          target="_blank"
          rel="noreferrer"
          className="font-semibold underline hover:text-amber-700 inline-flex items-center gap-1"
          data-testid="disclaimer-official-link"
        >
          dutchgymnastics.nl <ExternalLink size={12} />
        </a>
        .
      </div>
      <button onClick={() => setHidden(true)} className="text-amber-700 hover:text-amber-900" data-testid="dismiss-disclaimer">
        <X size={16}/>
      </button>
    </div>
  );
}
